Ext.define('SA.HistogramXScale', {
    constructor({ticks, frameSize, tickLabelFormatter}) {
        var domain = d3.extent(ticks),
            range = [0, frameSize.width],
            formatter = SA.TickFormatter.get({values: ticks, formatter: tickLabelFormatter});

        this.scale = d3.scaleLinear().domain(domain).range(range);
        this.ticks = ticks.map(value => ({x: this.getXForValue(value), label: formatter.format(value)}));
    },

    getXForValue(value) {
        return this.scale(value);
    },

    mapTicks(fn) {
        return this.ticks.map(fn);
    }
});